import React from "react";
import Sidebar from "../Sidebar/index.js";
import styles from "./TwoColumnLayout.module.css";
import { mcn } from "../../../utils/mergeClassnames.js";
function TwoColumnLayout(props) {
    const { children, sidebar, transparent, singleColumn, hideContent = true, sidebarContentLocation } = props;
    return (React.createElement("section", { className: mcn(styles.root, singleColumn && styles.rootRes) },
        singleColumn && sidebarContentLocation === "top" ? (React.createElement("div", { className: mcn(styles.sidebar, styles.sidebarResponsiveTop) },
            React.createElement(Sidebar, { transparent: transparent }, sidebar))) : null,
        React.createElement("div", { className: mcn(styles.content, singleColumn && styles.contentRes) }, children),
        !singleColumn && hideContent ? (React.createElement("div", { className: styles.sidebar },
            React.createElement(Sidebar, { transparent: transparent }, sidebar))) : null,
        singleColumn && sidebarContentLocation === "bottom" ? (React.createElement("div", { className: mcn(styles.sidebar, styles.sidebarResponsiveBottom) },
            React.createElement(Sidebar, { transparent: transparent }, sidebar))) : null));
}
export default TwoColumnLayout;
